<h3 mat-dialog-title>
  {{ 'dialog.add_organization.title' | translate: {
  organizationUnitType: data.organizationUnitType | ou_type_name | translate,
  parentOrganizationName: data.parentOU?.name || undefined
  } }}
</h3>
<mat-dialog-content class="add-organization-dialog-content" scrollEnd (endReached)="scrollEndReached()">
  @if (loading$ | async) {
    <mat-spinner class="center-horizontal"></mat-spinner>
  }
  @if (!(loading$ | async) && (data.organizationUnitType === EOrganizationUnitType.LOCATION || konnectDetails || jibbieDetails)) {
    <mat-tab-group
      [(selectedIndex)]="selectedTab"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      >
      @if ((isAdmin$ | async) && data.organizationUnitType === EOrganizationUnitType.LOCATION) {
        <mat-tab [label]="'dialog.add_organization.lrk_location.label' | translate">
          <form [formGroup]="lrkSearch" text-center>
            <mat-form-field class="org-location" appearance="outline">
              <mat-label>{{ 'dialog.add_organization.lrk_location.label' | translate }}</mat-label>
              <input formControlName="name" matInput (keydown.enter)="$event.preventDefault()" />
            </mat-form-field>
            <div class="lrk-search-results">
              @for (organization of lrkSearchResults$ | async; track organization) {
                <mat-card class="result-card" appearance="outlined">
                  <mat-card-header>
                    <mat-icon mat-card-avatar svgIcon="doenkids-location"></mat-icon>
                    <mat-card-title>{{ organization.actuele_naam_oko }}</mat-card-title>
                    <mat-card-subtitle>
                      <strong>{{ organization.lrk_id }} </strong>
                      @if (organization.correspondentie_adres) {
                        <span>{{ organization.correspondentie_adres }}, </span>
                      }
                      @if (organization.correspondentie_postcode) {
                        <span>{{ organization.correspondentie_postcode }}, </span>
                      }
                      @if (organization.correspondentie_woonplaats) {
                        <span>{{ organization.correspondentie_woonplaats }}</span>
                      }
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content>
                    <p>
                      @if (organization.naam_houder || organization.status) {
                        <span>
                          {{
                          'dialog.add_organization.lrk_location.details'
                          | translate: { owner: organization.naam_houder || undefined, status: organization.status || undefined }
                          }}
                        </span>
                      }
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <button (click)="linkLRKToOU(organization)" mat-button>{{ 'generic.link' | translate | uppercase }}</button>
                  </mat-card-actions>
                </mat-card>
              }
            </div>
          </form>
        </mat-tab>
      }
      @if (konnectDetails) {
        <mat-tab
      [label]="
        'dialog.add_organization.tab.konnect'
          | translate
            : {
                organizationUnitType: data.organizationUnitType | ou_type_name | translate
              }
      "
        >
        <form [formGroup]="konnectSearch" text-center>
          <mat-form-field class="organization-name" appearance="outline">
            <mat-label>
              {{
              'dialog.add_organization.konnect.label'
              | translate
              : {
              organizationUnitType: data.organizationUnitType | ou_type_name | translate
            }
            }}
          </mat-label>
          <input formControlName="name" matInput />
        </mat-form-field>
        <div class="konnect-search-results">
          @if (data.organizationUnitType === EOrganizationUnitType.LOCATION && konnectDetails) {
            @for (konnectLocation of konnectLocationResults$ | async; track konnectLocation) {
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-icon mat-card-avatar svgIcon="doenkids-location"></mat-icon>
                  <mat-card-title
                    >{{ konnectLocation.name }} <span class="konnect-title-suffix">({{ konnectLocation.type_oko }})</span></mat-card-title
                    >
                    <mat-card-subtitle>
                      <strong>{{ konnectLocation.konnect_id }} </strong>
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content>
                    <p>
                      @if (konnectLocation.street) {
                        <span>{{ konnectLocation.street }}</span
                          >
                          }&nbsp;
                          @if (konnectLocation.housenumber) {
                            <span>{{ konnectLocation.housenumber }}</span>
                          }
                        </p>
                        <p>
                          @if (konnectLocation.postalcode) {
                            <span>{{ konnectLocation.postalcode }}</span
                              >
                              }&nbsp;
                              @if (konnectLocation.city) {
                                <span>{{ konnectLocation.city }}</span>
                              }
                            </p>
                          </mat-card-content>
                          <mat-card-actions>
                            <button (click)="linkKonnectLocationToOrganization(konnectLocation)" mat-button>
                              {{ 'generic.link' | translate | uppercase }}
                            </button>
                          </mat-card-actions>
                        </mat-card>
                      }
                    }
                    @if (data.organizationUnitType === EOrganizationUnitType.GROUP) {
                      @for (konnectGroup of konnectGroupResults$ | async; track konnectGroup) {
                        <mat-card appearance="outlined">
                          <mat-card-header>
                            <mat-icon mat-card-avatar svgIcon="doenkids-group"></mat-icon>
                            <mat-card-title
                              >{{ konnectGroup.name }} <span class="konnect-title-suffix">({{ konnectGroup.type_oko }})</span></mat-card-title
                              >
                              <mat-card-subtitle>
                                <strong>{{ konnectGroup.konnect_id }} </strong>
                              </mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-actions>
                              <button (click)="linkKonnectGroupToOrganization(konnectGroup)" mat-button>
                                {{ 'generic.link' | translate | uppercase }}
                              </button>
                            </mat-card-actions>
                          </mat-card>
                        }
                      }
                    </div>
                  </form>
                </mat-tab>
              }
              @if (jibbieDetails) {
                <mat-tab
      [label]="
        'dialog.add_organization.tab.jibbie'
          | translate
            : {
                organizationUnitType: data.organizationUnitType | ou_type_name | translate
              }
      "
                >
                <form [formGroup]="jibbieSearch" text-center>
                  <mat-form-field class="organization-name" appearance="outline">
                    <mat-label>
                      {{
                      'dialog.add_organization.jibbie.label'
                      | translate
                      : {
                      organizationUnitType: data.organizationUnitType | ou_type_name | translate
                    }
                    }}
                  </mat-label>
                  <input formControlName="name" matInput />
                </mat-form-field>
                <div class="jibbie-search-results">
                  @if (data.organizationUnitType === EOrganizationUnitType.LOCATION && jibbieDetails) {
                    @for (jibbieLocation of jibbieLocationResults$ | async; track jibbieLocation) {
                      <mat-card appearance="outlined">
                        <mat-card-header>
                          <mat-icon mat-card-avatar svgIcon="doenkids-location"></mat-icon>
                          <mat-card-title
                            >{{ jibbieLocation.name }} <span class="jibbie-title-suffix">({{ jibbieLocation.type }})</span></mat-card-title
                            >
                            <mat-card-subtitle>
                              <strong>{{ jibbieLocation.external_id }} </strong>
                            </mat-card-subtitle>
                          </mat-card-header>
                          <mat-card-content>
                            <p>
                              @if (jibbieLocation.street) {
                                <span>{{ jibbieLocation.street }}</span
                                  >
                                  }&nbsp;
                                  @if (jibbieLocation.housenumber) {
                                    <span>{{ jibbieLocation.housenumber }}</span>
                                  }
                                </p>
                                <p>
                                  @if (jibbieLocation.postalcode) {
                                    <span>{{ jibbieLocation.postalcode }}</span
                                      >
                                      }&nbsp;
                                      @if (jibbieLocation.city) {
                                        <span>{{ jibbieLocation.city }}</span>
                                      }
                                    </p>
                                  </mat-card-content>
                                  <mat-card-actions>
                                    <button (click)="linkJibbieLocationToOrganization(jibbieLocation)" mat-button>
                                      {{ 'generic.link' | translate | uppercase }}
                                    </button>
                                  </mat-card-actions>
                                </mat-card>
                              }
                            }
                            @if (data.organizationUnitType === EOrganizationUnitType.ORGANIZATION) {
                              @for (jibbieOrganisation of jibbieOrganisationResults$ | async; track jibbieOrganisation) {
                                <mat-card appearance="outlined">
                                  <mat-card-header>
                                    <mat-icon mat-card-avatar svgIcon="doenkids-group"></mat-icon>
                                    <mat-card-title>{{ jibbieOrganisation.name }}</mat-card-title>
                                    <mat-card-subtitle>
                                      <strong>{{ jibbieOrganisation.slug }} </strong>
                                    </mat-card-subtitle>
                                  </mat-card-header>
                                  <mat-card-actions>
                                    <button (click)="linkJibbieOrganisationToOrganization(jibbieOrganisation)" mat-button>
                                      {{ 'generic.link' | translate | uppercase }}
                                    </button>
                                  </mat-card-actions>
                                </mat-card>
                              }
                            }
                          </div>
                        </form>
                      </mat-tab>
                    }
                    <mat-tab
      [label]="
        'dialog.add_organization.tab.create'
          | translate
            : {
                organizationUnitType: data.organizationUnitType | ou_type_name | translate
              }
      "
                    >
                    <ng-container *ngTemplateOutlet="newOrganizationTemplate"></ng-container>
                  </mat-tab>
                </mat-tab-group>
              }
              @if (!(loading$ | async) && data.organizationUnitType !== EOrganizationUnitType.LOCATION && !konnectDetails && !jibbieDetails) {
                <div>
                  <ng-container *ngTemplateOutlet="newOrganizationTemplate"></ng-container>
                </div>
              }
            </mat-dialog-content>
            <mat-dialog-actions class="save-button-container">
              <button (click)="createNewOrganization()" [disabled]="!newOrganization.valid" mat-button>
                {{ 'generic.save' | translate }}
              </button>
            </mat-dialog-actions>

            <ng-template #newOrganizationTemplate>
              @if (newOrganization) {
                <form [formGroup]="newOrganization">
                  <div class="org-name flex-row gap-4">
                    <mat-form-field appearance="outline" [style.flex]="data.organizationUnitType === EOrganizationUnitType.LOCATION ? '0 0 50%' : '0 0 100%'">
                      <mat-label>{{ 'organization.name.label' | translate }}</mat-label>
                      <input type="text" formControlName="name" matInput required [errorStateMatcher]="errorStateMatcher" />
                      @if (newOrganization.get('name').hasError('required')) {
                        <mat-error>
                          {{ 'generic.form.required_field' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (data.organizationUnitType === EOrganizationUnitType.LOCATION) {
                      <mat-form-field class="select" appearance="outline" style="flex: 0 0 50%;">
                        <mat-label>{{ 'organization.location_type.label' | translate }}</mat-label>
                        <mat-select placeholder="Type" formControlName="activityType" [errorStateMatcher]="errorStateMatcher">
                          @for (type of possibleActivityTypes; track type) {
                            <mat-option [value]="type.id">
                              {{ type.name }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (newOrganization.get('activityType').hasError('required')) {
                          <mat-error>
                            {{ 'generic.form.required_field' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    }
                  </div>
                  @if (isAdmin$ | async) {
                    <div class="org-address flex-row gap-4">
                      <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                        <mat-label>{{ 'organization.address.label' | translate }}</mat-label>
                        <input type="text" formControlName="address" matInput [errorStateMatcher]="errorStateMatcher"/>
                        @if (newOrganization.get('address').hasError('required')) {
                          <mat-error>
                            {{ 'generic.form.required_field' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                        <mat-label>{{ 'organization.postal_code.label' | translate }}</mat-label>
                        <input type="text" formControlName="postalcode" matInput [errorStateMatcher]="errorStateMatcher"/>
                        @if (newOrganization.get('postalcode').hasError('required')) {
                          <mat-error>
                            {{ 'generic.form.required_field' | translate }}
                          </mat-error>
                        }
                        @if (newOrganization.get('postalcode').hasError('pattern')) {
                          <mat-error>
                            {{ 'generic.form.invalid_postal_code' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="org-city flex-row gap-4">
                      <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                        <mat-label>{{ 'organization.city.label' | translate }}</mat-label>
                        <input type="text" formControlName="city" matInput [errorStateMatcher]="errorStateMatcher"/>
                        @if (newOrganization.get('city').hasError('required')) {
                          <mat-error>
                            {{ 'generic.form.required_field' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                        <mat-label>{{ 'organization.phone_number.label' | translate }}</mat-label>
                        <input type="text" formControlName="phone_number" matInput [errorStateMatcher]="errorStateMatcher"/>
                        @if (newOrganization.get('phone_number').hasError('required')) {
                          <mat-error>
                            {{ 'generic.form.required_field' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="flex-row gap-4">
                      <mat-form-field appearance="outline" [style.flex]="data.parentOU ? '0 0 100%' : '0 0 50%'">
                        <mat-label>{{ 'organization.email.label' | translate }}</mat-label>
                        <input type="text" formControlName="email" matInput [errorStateMatcher]="errorStateMatcher" />
                        @if (newOrganization.get('email').hasError('required')) {
                          <mat-error>
                            {{ 'generic.form.required_field' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                      @if (!data.parentOU) {
                        <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                          <mat-label>{{ 'organization_unit.country.label' | translate }}</mat-label>
                          <mat-select formControlName="country" required [errorStateMatcher]="errorStateMatcher">
                            <mat-select-trigger>
                              {{ getCountryLabel(newOrganization.get('country').value) }}
                            </mat-select-trigger>
                            @for (country of localSupportedCountries; track country) {
                              <mat-option [value]="country.countryCode">
                                {{ country.viewValue | translate }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (newOrganization.get('country').hasError('required')) {
                            <mat-error>
                              {{ 'generic.form.required_field' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      }
                    </div>
                    @if (data.parentOU) {
                      <div class="org-content flex-row gap-4">
                        <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                          <mat-label>{{ 'organization_unit.country.label' | translate }}</mat-label>
                          <mat-select formControlName="country" required [errorStateMatcher]="errorStateMatcher">
                            <mat-select-trigger>
                              {{ getCountryLabel(newOrganization.get('country').value) }}
                            </mat-select-trigger>
                            @for (country of localSupportedCountries; track country) {
                              <mat-option [value]="country.countryCode">
                                {{ country.viewValue | translate }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (newOrganization.get('country').hasError('required')) {
                            <mat-error>
                              {{ 'generic.form.required_field' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                        @if (data.parentOU) {
                          <mat-form-field appearance="outline" style="flex: 0 0 50%;">
                            <mat-label>{{ 'content_language.posbbile.label' | translate }}</mat-label>
                            <mat-select multiple formControlName="contentLanguages" [errorStateMatcher]="errorStateMatcher">
                              @for (contentLanguage of possibleContentLanguages$ | async; track contentLanguage) {
                                <mat-option [value]="contentLanguage">
                                  {{ 'generic.language.' + contentLanguage.toLowerCase() | translate | titlecase }}
                                </mat-option>
                              }
                            </mat-select>
                            @if (newOrganization.get('contentLanguages').hasError('required')) {
                              <mat-error>{{ 'generic.language.form.required' | translate }}</mat-error>
                            }
                          </mat-form-field>
                        }
                      </div>
                    }
                  }
                  @if (isAdmin$ | async) {
                    <div class="checkbox-wrapper flex-col gap-4">
                      <mat-checkbox formControlName="template_settings">
                        {{ 'dialog.add_organization.template_settings' | translate }}
                      </mat-checkbox>
                      <mat-checkbox formControlName="customer_symbols">
                        {{ 'dialog.add_organization.customer_symbols' | translate }}
                      </mat-checkbox>
                      <mat-checkbox formControlName="i18n_translate">
                        {{ 'dialog.add_organization.i18n_translate' | translate }}
                      </mat-checkbox>
                      <mat-checkbox formControlName="activity_copy">
                        {{ 'dialog.add_organization.activity_copy' | translate }}
                      </mat-checkbox>
                      <mat-checkbox formControlName="program_template_create">
                        {{ 'dialog.add_organization.program_template_create' | translate }}
                      </mat-checkbox>
                      <mat-checkbox formControlName="disable_activity_create">
                        {{ 'dialog.add_organization.disable_activity_create' | translate }}
                      </mat-checkbox>
                      @if (isOrganizationOfTypeCustomer$ | async) {
                        <mat-checkbox formControlName="konnect_integration">
                          {{ 'dialog.add_organization.konnect_integration' | translate }}
                        </mat-checkbox>
                      }
                    </div>
                  }
                </form>
              }
            </ng-template>
